import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
  View,
  ScrollView,
  Image,
  Platform,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
  SafeAreaView,
  Linking,
  Modal,
} from 'react-native';
import {StyleSheet} from 'react-native';
import {colorPalette, colors} from '../../../core/config/color.config';

import {useNavigation} from '@react-navigation/native';

import {useToast} from 'react-native-fast-toast';

import {width, height, totalSize} from 'react-native-dimension';

import useStores from '../../stores/useStores';
import {HeaderBackLeft} from '../../views';
import {RNEText, SVGIcon} from '../../components';
import {Text} from 'react-native';
import moment from 'moment';
import {Icon, Overlay} from 'react-native-elements';
import {
  Bubble,
  GiftedChat,
  InputToolbar,
  Message,
  Time,
} from 'react-native-gifted-chat';
import {
  useGetDoctorAdminMessage,
  useSendDoctorAdminMessage,
} from '../../server/react-query/useAdminChat';
import {SendMessageReqBody} from '../../server/types/doctor-admin-chat.types';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';

import {launchCamera, launchImageLibrary} from 'react-native-image-picker';
import AdminDoctorChat from '../../views/chat/AdminDoctorChat';

const DoctorAdminChat = () => {
  const navigation = useNavigation();
  const {authStore} = useStores();
  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: {errors, isValid},
  } = useForm<SendMessageReqBody>({
    mode: 'all',
    defaultValues: {
      senderType: 'practitioner',
      messageText: '',
      attachmentUrl: '',
    },
    // resolver: yupResolver(schema),
  });

  const [messages, setMessages] = useState([]);
  const user = authStore.authData?.user!;
  const toast = useToast();
  const [message, setMessage] = useState('');

  const {data, refetch} = useGetDoctorAdminMessage();

  const sendMessageMutate = useSendDoctorAdminMessage();

  const [doctorAdminMessages, setDoctorAdminMessages] = useState([]);

  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    setDoctorAdminMessages([]);
    // console.log(user?.practitionerId, 'user');
    if (data && Object.keys(data).length > 0) {
      if (data?.messages) {
        // console.log(data?.messages);
        const mapped = data.messages.map((message, idx) => ({
          _id: message.id ?? `msg-${idx}-${Date.now()}`,
          text: message.messageText || '',
          createdAt: message.createdAt
            ? new Date(message.createdAt)
            : new Date(),
          user:
            message.senderType === 'practitioner'
              ? {
                  _id: user?.practitionerId ?? 'patient-unknown',
                  name: [user?.firstName, user?.middleName, user?.lastName]
                    .filter(Boolean)
                    .join(' '),
                }
              : {
                  _id: data?.adminId ?? 'admin-unknown',
                  name: 'Admin',
                },
          file: message.file || null,
        }));

        // 🔑 Sort by createdAt descending (newest first, required by GiftedChat)
        const sorted = mapped.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        );

        setDoctorAdminMessages(sorted);
      }
    }
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => {
      refetch(); // from your useGetDoctorAdminMessage()
    }, 5000); // every 5 sec

    return () => clearInterval(interval);
  }, [refetch]);

  // useEffect(() => {
  //   console.log(showPicker, 'showPicker');
  // }, [showPicker]);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTitleAlign: 'left',
      headerTitle: 'Housecall Administrator',
      headerStyle: {
        elevation: 0,
        shadowOpacity: 0,
        backgroundColor: colorPalette.white,
        borderBottomColor: colorPalette.grey,
        borderBottomWidth: totalSize(0.1),
      },
      headerTintColor: colorPalette.blackLight,
      headerTitleStyle: {
        fontWeight: '800',
        fontFamily: 'Quicksand-Medium',
        fontSize: totalSize(2),
        color: colorPalette.blackLight,
      },
      headerLeft: () => <HeaderBackLeft iconName="left-arrow-dark-blue" removeLabel customMainContainerStyle={{paddingHorizontal: totalSize(0.5)}}  />,
      headerRight: () => {},
    });
  }, [navigation]);

  const requestCameraPermission = async () => {
    if (Platform.OS !== 'android') {
      // Web & iOS don’t need this
      return true;
    }
    try {
      const {PermissionsAndroid} = require('react-native');

      const granted = await PermissionsAndroid.request(
        PermissionsAndroid.PERMISSIONS.CAMERA,
        {
          title: 'Camera Permission',
          message: 'This app needs access to your camera to take photos.',
          buttonNeutral: 'Ask Me Later',
          buttonNegative: 'Cancel',
          buttonPositive: 'OK',
        },
      );
      return granted === PermissionsAndroid.RESULTS.GRANTED;
    } catch (err) {
      console.warn(err);
      return false;
    }
  };

  const handleSendPress = () => {
    handleSubmit(sendMessageRequestFunc)();
  };

  const sendMessageRequestFunc = async () => {
    if (getValues().messageText.trim()) {
      const newMessage = {
        _id: Math.random().toString(),
        text: getValues().messageText,
        createdAt: moment.utc().toDate(),
        user: {
          _id: user?.practitionerId || 1,
          name:
            [user?.firstName, user?.middleName, user?.lastName]
              .filter(Boolean)
              .join(' ') || 'Me',
        },
      };
      setDoctorAdminMessages(prev => GiftedChat.append(prev, [newMessage]));
      const formValues = getValues();
      reset();
      await sendMessageMutate.mutateAsync(formValues);
    }
  };

  const openCamera = async () => {
    if (Platform.OS === 'android') {
      const hasPermission = await requestCameraPermission();
      if (!hasPermission) {
        toast.show('Camera permission denied', {type: 'danger'});
        return;
      }
    }

    const result = await launchCamera({
      mediaType: 'photo',
      includeBase64: true,
    });
    if (result.assets?.[0]) addFile(result.assets[0]);
    setShowPicker(false);
  };

  const openGallery = async () => {
    const result = await launchImageLibrary({
      mediaType: 'photo',
      includeBase64: true,
    });
    if (result.assets?.[0]) addFile(result.assets[0]);
    setShowPicker(false);
  };

  const openFile = async () => {
    if (Platform.OS === 'android') {
      try {
        const DocumentPicker = require('react-native-document-picker').default;

        const res = await DocumentPicker.pick({
          type: [
            DocumentPicker.types.images,
            DocumentPicker.types.pdf,
            DocumentPicker.types.doc,
            DocumentPicker.types.docx,
          ],
        });
        if (res[0]) {
          const RNFS = require('react-native-fs');
          const base64 = await RNFS.readFile(res[0].uri, 'base64');
          addFile({...res[0], base64});
        }
      } catch (e) {
        console.log(e);
      }
      setShowPicker(false);
    }
  };

  const addFile = file => {
    // console.log(file);
    // return false;
    const newMessage = {
      _id: Math.random().toString(),
      text: '',
      createdAt: moment.utc().toDate(),
      user: {
        _id: user?.practitionerId,
        name:
          [user?.firstName, user?.middleName, user?.lastName]
            .filter(Boolean)
            .join(' ') || 'Me',
      },
      file,
    };
    setDoctorAdminMessages(prev => GiftedChat.append(prev, [newMessage]));
  };

  const renderMessage = (props: any) => {
    const {currentMessage} = props;

    if (currentMessage?.file) {
      return (
        <Message
          {...props}
          renderBubble={() => (
            <View
              style={{
                padding: 10,
                backgroundColor: '#f0f0f0',
                borderRadius: 8,
                maxWidth: 220,
              }}>
              <Text style={{fontWeight: 'bold'}}>
                {currentMessage.file.name}
              </Text>

              <TouchableOpacity
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginTop: 5,
                }}
                onPress={() => Linking.openURL(currentMessage.file.url)}>
                <Icon
                  type="material-community"
                  name="download"
                  color={colorPalette.primary}
                  size={totalSize(3)}
                />
                <Text style={{color: '#007AFF', marginLeft: 5}}>Download</Text>
              </TouchableOpacity>
            </View>
          )}
        />
      );
    }

    // fallback → normal bubble
    return (
      <Message
        {...props}
        textStyle={{
          right: {
            // width: width(40),
            maxWidth: width(60),
            minWidth: width(40),
          },
        }}
      />
    );
  };

  // custom input toolbar with border + attach + send
  const renderInput = (props: any) => (
    <InputToolbar
      {...props}
      containerStyle={{
        borderTopWidth: totalSize(0.1),
        borderWidth: totalSize(0.1),
        borderColor: colorPalette.grey,
        borderRadius: totalSize(1.5),
        margin: totalSize(1),
        paddingHorizontal: width(1.5),
      }}
      primaryStyle={{alignItems: 'center'}}
      renderComposer={() => (
        <Controller
          control={control}
          render={({field: {onChange, onBlur, value}}) => (
            <TextInput
              placeholder="Type a message"
              placeholderTextColor={colors.gray.light}
              multiline
              value={value}
              onChangeText={text => {
                onChange(text);
              }}
              style={{
                flex: 1,
                fontSize: Platform.OS === 'web' ? totalSize(1) : totalSize(1.5),
                color: colorPalette.black,
                padding: 8,
                textAlignVertical: 'center',
              }}
            />
          )}
          name="messageText"
        />
      )}
      renderActions={() => (
        <TouchableOpacity
          onPress={() => setShowPicker(true)}
          style={{paddingHorizontal: width(1.5), paddingVertical: height(1.5)}}>
          <SVGIcon name="plus-circle-blue" />
        </TouchableOpacity>
      )}
      renderSend={() => (
        <TouchableOpacity
          onPress={() => handleSendPress()}
          style={{paddingHorizontal: width(1.5), paddingVertical: height(1)}}>
          <SVGIcon name="send-02" />
        </TouchableOpacity>
      )}
    />
  );

  return (
    <>
      <KeyboardAvoidingView
        style={{flex: 1}}
        behavior={Platform.OS === 'ios' ? 'padding' : undefined}
        keyboardVerticalOffset={Platform.OS === 'ios' ? height(12) : 0} // adjust based on header height
      >
        <SafeAreaView style={[{flex: 1, marginTop: height(2)}, Platform.OS === 'android' && {marginBottom: height(2)}]}>
          <AdminDoctorChat
            practitionerId={user?.practitionerId}
            senderType="practitioner"
            user={user}
          />
        </SafeAreaView>
      </KeyboardAvoidingView>
    </>
  );
};

export default DoctorAdminChat;
